import React from 'react';
import * as PropTypes from 'prop-types';
import Button from 'chameleon/ui-stack/ui/base/button';

const ButtonWithCount = ({ onClick, count, text }) => (
  <Button
    isLink
    isNaked
    accessibility={{
      ariaLabel: text,
    }}
    onClick={onClick}
    className="flex items-center"
  >
    <div className="flex items-center justify-center py-2 px-3.5 bg-blue-500 rounded-full text-white text-12">
      {count}
    </div>
    <div className="ml-2 text-12">{text}</div>
  </Button>
);

ButtonWithCount.propTypes = {
  onClick: PropTypes.func,
  count: PropTypes.number,
  text: PropTypes.string,
};

export default ButtonWithCount;
